import * as React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { facultyProps } from '@/types';
import facultyService from '@/api/faculty.service';
import './Modals.scss'
import { tokens } from '@/utilities';
import { useNavigate } from 'react-router-dom';

interface Props {
  code: string | undefined;
}

export function ModalCareers({ code }: Props) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  
  const [faculties, setFaculties] = React.useState<facultyProps[]>([]);

  const handleFacultyClick = (faculty: facultyProps) => {
    if (code && faculty.id) {
      navigate(`/faculty/${code}/${faculty.id}`, { state: { facultyName: faculty.name } });
    }
  };

  React.useEffect(() => {
    let isMounted = true;
  
    async function facultyDataAPI() {
      try {
        if (code && isMounted) {
          const facultyData = await facultyService.getAll(code);
          if (isMounted) {
            setFaculties(facultyData);
          }
        }
      } catch (error) {
        console.error('Error to catch data faculty:', error);
      }
    }
  
    facultyDataAPI();
  
    return () => {
      isMounted = false; 
    };
  }, [code]);

  return (
    <Box 
      sx={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {faculties.length > 0 
        ? faculties.map((faculty, index) => (
          <Button 
            sx={{
              width: "100%",
              padding: "5px 15px",
              marginBottom: "15px",
              fontWeight: "bolder",
              color: colors.grey[100],
              "&:hover": {
                backgroundColor: colors.greenAccent[500],
                color: colors.primary[400],
                scale: "1.2"
              }
            }}
            key={index} 
            onClick={() => handleFacultyClick(faculty)}
          >
            {faculty.name}
          </Button>
        ))
        : ''    
      }
    </Box>
  );
}